import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';

import { Button } from 'muicss/react';
import Tabs from 'muicss/lib/react/tabs';
import Tab from 'muicss/lib/react/tab';

import DateUtilities from 'records/DateUtilities';
import { getCurrentUserBrand } from 'selectors/user-brands';
import IngredientReplacement from 'containers/NotificationsCenter/IngredientReplacement';
import { getWeightUnitTypes } from 'selectors/type-items';
import Ingredient from 'records/Ingredient';
import { createEvent } from 'googleanalytics';

// constants
import { inputDateFormatTS, displayMonthDateFormat } from 'constants/globalPrice';
import {
  source as SOURCE,
  notificationsCenterTabs,
  notificationsCenterSteps,
  resolveBypassSet,
} from 'constants/notifications';
import { REPLACEMENT_PARAMS } from 'components/NotificationsCenter/SetQuantity';
import { types } from 'constants/types';
import { ingredientsSearchTabs } from 'constants/ingredientsSearch';
import { ingredientTypeMap } from 'constants/ingredientType';
import { CATEGORIES, ACTIONS } from 'constants/googleAnalytics';
import { GBP_LOCATIONS_LINK } from 'constants/gbp';

// helpers
import { getMatchingUnits } from 'helpers/typeItemHelper';
import { getFilteredNotifications, getAllowedTabList } from 'components/NotificationsCenter/notificationsHelper';
import { getPriceEffectiveDate } from 'helpers/globalPriceHelper';
import { isSupc } from 'components/IngredientsSearch/ingredientsSearchHelper';

//actions
import { listCustomUomAsync, listCommonCustomUomAsync } from 'actions/customUom';
import {
  fetchNotificationsAsync,
  updateNotificationAsync,
  fetchIngredientUsedInRecipesAsync,
  setNotificationStep,
  setSelectedNotification,
  setNotificationCenterModalState,
} from 'actions/notifications';
import { updateSearchKeyword, resetTabFilters, getProductCatalogue, resetAll } from 'actions/ingredientsSearch';
import { replaceCostRollUp } from 'actions/notifications';
import { getSyscoProducts } from 'actions/syscoProducts';

// componenets
import Modal from 'components/Modal';
import Notification from 'components/NotificationsCenter/Notification';
import SearchPanel from 'components/SearchPanel';
import SetQuantity from 'components/NotificationsCenter/SetQuantity';
import { getTypeItemsByTypeAsync } from 'actions/type-items';


@connect(state => ({
  currentBrand: getCurrentUserBrand(state),
  notifications: state.notifications,
  user: state.user.get('data'),
  ingredients: state.ingredients.get('data'),
  recipe: state.batchrecipe.get('data'),
  ingredientsSearch: state.ingredientsSearch,
  selectedSearchTab: state.ingredientsSearch.selectedTab,
  selectedFilters: state.ingredientsSearch.selectedFilters,
  selectedIngredients: state.ingredientsSearch.selectedIngredients,
  loading: state.ingredientsSearch.loading,
  commonCustomUom: state.customUom.get('common'),
  unitTypes: getWeightUnitTypes(state),
  selectedNotification: state.notifications.selectedNotification,
  step: state.notifications.step,
  isLoading: state.notifications.isLoading,
}))

class NotificationsCenter extends Component {
  static propTypes = {
    ingredients: PropTypes.object,
    isModalOpen: PropTypes.bool,
    currentBrand: PropTypes.object,
    notifications: PropTypes.object,
    dispatch: PropTypes.func,
    user: PropTypes.object,
    recipe: PropTypes.object,
    ingredientsSearch: PropTypes.object,
    selectedSearchTab: PropTypes.string,
    unitTypes: PropTypes.object,
    selectedNotification: PropTypes.object,
    step: PropTypes.number,
    isLoading: PropTypes.bool,
  };

  constructor() {
    super();
    this.state = {
      searchText: '',
      selectedTab: notificationsCenterTabs[0],
      isUnableToResolveModalOpen: false,
      ingredientToResolve: null,
      selectedIngredient: null,
      heading: '',
      replaceParams: {},
      selectedIngUnits: null,
    };
  }

  componentDidMount() {
    const { dispatch, user } = this.props;
    // check whether user details are loaded (needed for x-opco-account header)
    if (user.get('opcoId')) {
      dispatch(fetchNotificationsAsync());
    }
  }

  componentDidUpdate({
    user: prevUser,
    currentBrand: prevBrand,
    isModalOpen: wasModalOpen,
    notifications: { source: prevSource },
  }) {
    const {
      dispatch,
      notifications,
      user,
      currentBrand,
      isModalOpen,
      unitTypes,
      selectedNotification,
    } = this.props;

    // check whether user details are updated (needed for x-opco-account header)
    if (!notifications.isLoading &&
      ((!prevUser.get('opcoId') && user.get('opcoId')) || (prevBrand && currentBrand.get('id') !== prevBrand.get('id')))) {
      dispatch(fetchNotificationsAsync());
    }

    if (!wasModalOpen && isModalOpen) {
      if (!unitTypes || !unitTypes.size) {
        dispatch(listCustomUomAsync());
        dispatch(listCommonCustomUomAsync());
        dispatch(getTypeItemsByTypeAsync(types.WEIGHT_UNIT.TEXT_KEY));
      }
      if (prevSource !== notifications.source && resolveBypassSet.includes(notifications.source)) {
        this.handleResolve(selectedNotification.data.supc, true);
      }
    }
  }

  closeModal = () => {
    const { dispatch, notifications: { source } } = this.props;

    this.setState({
      selectedTab: notificationsCenterTabs[0],
      searchText: '',
      ingredientToResolve: null,
      selectedIngredient: null,
      heading: '',
    });

    dispatch(setNotificationCenterModalState(false, source.NOTIFICATIONS));
    dispatch(setNotificationStep(notificationsCenterSteps.NOTIFICATIONS_STEP));
    dispatch(setSelectedNotification(null));

    this.resetIngredientsSearch();
  };

  /**
   * Change Notifications Center tabs
   */
  handleTabChange = (index) => {
    this.setState({ selectedTab: notificationsCenterTabs[index] });
  }

  /**
   * Update the search text in state
   * @param {String} actionType type of the change occured. eg: KeyChange, Search, Enter
   * @param {String} searchText text in the search box
   * @param {Boolean} updated whether the text is updated from the last time
   */
  handleSearch = (actionType, searchText, updated) => {
    const respondGroup = ['Enter', 'Search'];
    if (respondGroup.includes(actionType) && updated) {
      this.setState({ searchText });
    }
  }

  fetchProductCatalogue = keyword => {
    const { dispatch } = this.props;
    dispatch(resetTabFilters(ingredientsSearchTabs.FULL_PRODUCT_CATALOG_TAB.key));
    return dispatch(getProductCatalogue(keyword));
  };

  handleIngredientSearch = (actionType, keyword, updated) => {
    const respondGroup = ['Enter', 'Search'];
    const { dispatch, ingredientsSearch, selectedSearchTab } = this.props;

    if (respondGroup.includes(actionType) && updated) {
      if (selectedSearchTab === ingredientsSearchTabs.FULL_PRODUCT_CATALOG_TAB.key) {
        if (keyword) {
          this.fetchProductCatalogue(keyword);
        } else {
          this.resetTab(ingredientsSearchTabs.FULL_PRODUCT_CATALOG_TAB.key);
        }
      }
      dispatch(updateSearchKeyword(keyword, isSupc(keyword), ingredientsSearch.search.searchedTabs));
    }
  }

  /**
   * Clear the search
   */
  handleClearSearch = () => {
    this.setState({ searchText: '' });
  }

  handleIngredientClear = () => {
    const { ingredientsSearch, dispatch, selectedSearchTab } = this.props;
    dispatch(updateSearchKeyword(null, false, ingredientsSearch.search.searchedTabs));
    if (selectedSearchTab === ingredientsSearchTabs.FULL_PRODUCT_CATALOG_TAB.key) {
      this.resetTab(ingredientsSearchTabs.FULL_PRODUCT_CATALOG_TAB.key);
    }
  }

  renderBody() {
    switch (this.props.step) {
      case notificationsCenterSteps.NOTIFICATIONS_STEP:
        return this.renderNotificationCenterBody();
      case notificationsCenterSteps.INGREDIENT_REPLACEMENT_STEP:
        return this.renderIngredientReplacementBody();
      case notificationsCenterSteps.SET_QUANTITY_STEP:
        return this.renderSetQuantityBody();
      default:
        return (<div></div>);
    }
  }

  /**
   * handle notification resolve button click
   * @param {Object} notification selected notification object
   */
  handleClickResolve = notification => {
    const { dispatch, selectedNotification, user } = this.props;

    dispatch(setSelectedNotification(notification));
    this.handleResolve(notification.data.supc, Object.keys(selectedNotification).length && selectedNotification.data.supc !== notification.data.supc)

    if (notification.subCategory === 'INVALID_SPLIT_ITEM') {
      createEvent(CATEGORIES.GP, ACTIONS.RESOLVE_SPLIT_ITEM_ERRORS, `${user.get('opcoId')}-${user.get('syscoCustomerId')}`, user);
    }
    if (notification.subCategory === 'UNAVAILABLE_ITEM') {
      createEvent(CATEGORIES.GP, ACTIONS.RESOLVE_INGREDIENT_UNAVAILABILITY, `${user.get('opcoId')}-${user.get('syscoCustomerId')}`, user);
    }
  }

  /**
   * Handle resolve click on notification or ingredient section
   * @param {String} supc ingredient supc
   * @param {Boolean} shouldReset if trying to resolve a new notification, clear selected ingredient
   */
  handleResolve = (supc, shouldReset = false) => {
    const { dispatch } = this.props;

    if (shouldReset) {
      this.setState({ selectedIngredient: null });
      this.resetIngredientsSearch();
    }

    // fetch recipes with the ingredent
    dispatch(fetchIngredientUsedInRecipesAsync(supc))
      .then(ingredient => {
        if (ingredient && ingredient.usedInRecipes && ingredient.usedInRecipes.length > 0) {
          this.setState(
            { ingredientToResolve: ingredient },
            () => dispatch(setNotificationStep(notificationsCenterSteps.INGREDIENT_REPLACEMENT_STEP))
          );
        } else {
          // if no recipes found open alert modal
          this.setState({ isUnableToResolveModalOpen: true });
        }
      });
  }

  handleCloseNotification = (id) => {
    this.props.dispatch(updateNotificationAsync(id, 'CLOSED'));
  }

  handleVisitToGBP = (id) => {
    const { user } = this.props;
    const { opcoId, syscoCustomerId } = user;

    createEvent(CATEGORIES.GBP, ACTIONS.REDIRECT_TO_GBP_PAGE, `${opcoId}-${syscoCustomerId}`, user);
    window.open(GBP_LOCATIONS_LINK, '_blank');
    this.handleCloseNotification(id);
  }

  renderNotificationCenterBody() {
    const { notifications: { data }, user } = this.props;
    const { selectedTab, searchText } = this.state;
    const filteredNotifications = getFilteredNotifications(data, selectedTab, searchText);
    const userCountry = user.get('country');
    const filteredTabs = getAllowedTabList(userCountry);
    return (
      <div className={ 'common-overlay-content' }>
        <div className={ 'content-box-wrapper' }>
          <Tabs
            defaultSelectedIndex={ 0 }
            className={ 'custom-boxed-tab mt-30' }
            onChange={ this.handleTabChange }
            selectedIndex={ selectedTab.idx }
          >
            {
              filteredTabs.map(tab => (
                <Tab
                  label={ tab.title }
                  key={ tab.key }
                >
                  {
                    filteredNotifications.length === 0 ? (
                      <div className='no-data'>
                        <p className='mui--text-center no-data-text'>
                          No Notifications Available.
                        </p>
                      </div>
                    ) : (
                      <div className={ 'notifications-list' }>
                        {
                          filteredNotifications.map(notification => (
                            <Notification
                              notification={ notification }
                              handleClickResolve={ this.handleClickResolve }
                              key={ notification.id }
                              handleCloseNotification={ this.handleCloseNotification }
                              handleVisitToGBP={ this.handleVisitToGBP }
                            />
                          ))
                        }
                      </div>
                    )
                  }
                </Tab>
              ))
            }
          </Tabs>
          { this.renderUnableToResolveModal() }
        </div>
      </div>
    );
  }

  handleSelectIngredient = selectedIngredient => {
    this.setState(({ ingredientToResolve }) => {
      const { usedInRecipes } = ingredientToResolve;
      const replaceParams = {};
      const newAmountUnit = selectedIngredient.amountUnitTextKey;

      usedInRecipes.forEach(({ recipeId, amount, amountUnit, ingredientId, ordinal }) => {

        if (recipeId) {
          replaceParams[`${recipeId}:${ingredientId}`] = {
            [REPLACEMENT_PARAMS.YIELD]: selectedIngredient.yield || 100,
            [REPLACEMENT_PARAMS.QUANTITY]: newAmountUnit === amountUnit ? amount : 0,
            [REPLACEMENT_PARAMS.AMOUNT_UNIT]: newAmountUnit,
            [REPLACEMENT_PARAMS.COST_PER_SERVING]: 0,
            [REPLACEMENT_PARAMS.RECIPE_ID]: recipeId,
            [REPLACEMENT_PARAMS.INGREDIENT_ID]: ingredientId,
            [REPLACEMENT_PARAMS.ORDINAL]: ordinal,
          }
        }
      });

      const units = getMatchingUnits(new Ingredient(selectedIngredient), this.props.unitTypes);
      const mappedUnits = units.map(item => ({
        value: item.get('abbreviation'),
        label: `${item.get('typeItemName')}(${item.get('abbreviation')})`,
      }));

      return {
        selectedIngredient,
        replaceParams,
        selectedIngUnits: mappedUnits,
      }
    });
  }

  /**
   * Change individual replacement parameter
   * @param {Number} id recipeId
   * @param {String} field replacement field eg: yield, noOfEaches
   * @param {*} value replacing value
   */
  changeReplaceParams = (id, field, value) => {
    this.setState(({ replaceParams }) => ({
      replaceParams: {
        ...replaceParams,
        [id]: {
          ...replaceParams[id],
          [field]: value,
        }
      }
    }));
  }

  renderIngredientReplacementBody() {
    const { ingredients, recipe } = this.props;
    const { selectedIngredient } = this.state;
    const selectedKey = selectedIngredient ? selectedIngredient.tabName + selectedIngredient.id + selectedIngredient.supc : '';
    return (
      <div className={ 'common-overlay-content nc-item-replacement' }>
        <IngredientReplacement
          recipeIngredients={ ingredients }
          recipe={ recipe }
          handleSelectIngredient={ this.handleSelectIngredient }
          selectedKey={ selectedKey }
          isFromNotificationCenter={ true }
        />
      </div>
    );
  }

  /**
   * renders set-quantity body
   * @returns {Node} react node
   */
  renderSetQuantityBody = () => {
    const {
      ingredientToResolve,
      selectedIngredient,
      replaceParams,
      selectedIngUnits,
    } = this.state;

    return <SetQuantity
      currentIngredient={ingredientToResolve}
      selectedIngredient={selectedIngredient}
      newParams={replaceParams}
      setReplacementParams={this.changeReplaceParams}
      unitTypes={this.props.unitTypes}
      units={selectedIngUnits}
      dispatch={this.props.dispatch}
    />
  };

  renderHeader() {
    switch (this.props.step) {
      case notificationsCenterSteps.NOTIFICATIONS_STEP:
        return this.renderNotificationCenterHeader();
      case notificationsCenterSteps.INGREDIENT_REPLACEMENT_STEP:
        return this.renderIngredientReplacementHeader();
      case notificationsCenterSteps.SET_QUANTITY_STEP:
        return this.renderSetQuantityHeader();
      default:
        return (<div></div>);
    }
  }

  renderNotificationCenterHeader() {
    const { currentBrand, notifications: { data, searchKey } } = this.props;
    const priceEffectiveDate = getPriceEffectiveDate(currentBrand);
    const formattedPriceDate = priceEffectiveDate ? DateUtilities.convertTimeFormatLocal(priceEffectiveDate, inputDateFormatTS, displayMonthDateFormat) : '';

    return (
      <div className={ 'common-overlay-header flex items-start justify-between' }>
        <div>
          <h2 className={ 'm-0' }>Notifications Center</h2>
          {
            priceEffectiveDate ? (
              <p className={ 'modal-text-description text-italic font-small' }>Price Effective Date: { formattedPriceDate }</p>
            ) : null
          }
        </div>

        <div className={ 'searchbox-widget min-w-300 full-width-box' }>
          <SearchPanel
            onSearch={ this.handleSearch }
            onClear={ this.handleClearSearch }
            onItemClick={ () => {} }
            itemSource='MyIngredientItems'
            searchPlaceholder='Search Notifications'
            ingredientSearch={ true }
            keyword={ searchKey }
            disabled={ data.length === 0 }
          />
        </div>


      </div>
    );
  }

  /**
   * Dynamically render breadcrumbs based on the current selected step
   * @returns {Node} react node
   */
  renderBreadCrumbs() {
    const { notifications, step } = this.props;
    const commands = [];
    const BREAD_CRUMBS = ['All Notifications', 'Find Ingredient', 'Set Quantity'];
    const skipSteps = [notificationsCenterSteps.NOTIFICATIONS_STEP];
    const isByPassing = resolveBypassSet.includes(notifications.source);
    const indexStep = isByPassing ? notificationsCenterSteps.INGREDIENT_REPLACEMENT_STEP : notificationsCenterSteps.NOTIFICATIONS_STEP;

    for (let index = indexStep; index <= step; index++) {
      const isFinalStepYet = index === step;
      if (isByPassing && skipSteps.includes(index)) {
        continue;
      }

      commands.push({
        key: index,
        className: isFinalStepYet ? null : 'clickable-bc',
        onClick: () => isFinalStepYet ? () => { } : this.changeNotificationsTab(index),
        label: `${BREAD_CRUMBS[index - 1]}${isFinalStepYet ? '' : '/'}`,
      })
    }

    return (
      <div className={'flex notification-breadcrumb'}>
        {commands.map(command => (
          <span
            key={command.key}
            className={command.className}
            onClick={command.onClick}
          >
            {command.label}
          </span>))}
      </div>
    );
  }

  renderIngredientReplacementHeader() {
    const { ingredientsSearch, selectedNotification } = this.props;
    return (
      <div className={ 'common-overlay-header flex items-start justify-between' }>
      <div>
        { this.renderBreadCrumbs() }
        Replace : { selectedNotification.heading }
      </div>

        <div className='searchbox-widget  min-w-300 full-width-box'>
          <SearchPanel
            onSearch={ this.handleIngredientSearch }
            onClear={ this.handleIngredientClear }
            onItemClick={ () => {} }
            itemSource='MyIngredientItems'
            searchPlaceholder='Search Ingredients'
            ingredientSearch={ true }
            keyword={ ingredientsSearch.search.keyword }
          />

        </div>
      </div>
    );
  }

  renderSetQuantityHeader() {
    return (
      <div className={'common-overlay-header flex items-start justify-between'}>
        <div>
          {this.renderBreadCrumbs()}
          Set Quantity
        </div>
      </div>
    );
  }

  /**
   * Clear ingredient search state
   */
  resetIngredientsSearch = () => {
    this.props.dispatch(resetAll());
  }

  changeNotificationsTab = (step) => {
    this.props.dispatch(setNotificationStep(step));
    if (step === notificationsCenterSteps.SET_QUANTITY_STEP) {
      const { user } = this.props;
      createEvent(CATEGORIES.GP, ACTIONS.SELECT_REPLACEMENT_INGREDIENT, `${user.get('opcoId')}-${user.get('syscoCustomerId')}`, user);
    }
  }

  /**
   * save cost rollup data
   * @param {Object} selectedIngredient selected Ingredient
   * @param {Object} replaceParams replaced parameters
   * @param {Number} notificationId related notification ID
   * @param {String} oldIngredientSupc replacable ingredient SUPC
   */
  saveCostRollup = async (selectedIngredient, replaceParams, notificationId, oldIngredientSupc) => {
    const {
      dispatch,
      notifications: { source, data: notifications },
      currentBrand,
      user,
    } = this.props;
    const isBypassing = resolveBypassSet.includes(source);

    const usedInRecipes = Object.entries(replaceParams)
      .map(([_, {
        recipeId,
        quantity,
        amountUnitTextKey,
        yield: productYield,
        ingredientId,
        ordinal,
      }]) => ({
        recipeId,
        amount: parseFloat(quantity),
        amountUnit: amountUnitTextKey,
        yield: parseFloat(productYield),
        ingredientId,
        ordinal,
      }));

    createEvent(CATEGORIES.GP, ACTIONS.QTY_UPDATE_FOR_REPLACEMENT_INGREDIENT, `${user.get('opcoId')}-${user.get('syscoCustomerId')}`, user);
    if (isBypassing) {
      const notification = notifications &&
        notifications.length &&
        notifications.find(notification => notification.data && notification.data.supc === oldIngredientSupc);
      notificationId = notification && notification.id;
    }

    await dispatch(replaceCostRollUp({
      ...selectedIngredient,
      usedInRecipes,
      notificationId,
    }));
    if (isBypassing) {
      if (source === SOURCE.INGREDIENT_SECTION) {
        await dispatch(getSyscoProducts(currentBrand.get('id'), ingredientTypeMap.SYSCO_PRODUCTS));
      }
      this.closeModal();
    } else {
      this.changeNotificationsTab(notificationsCenterSteps.NOTIFICATIONS_STEP);
    }
    dispatch(fetchNotificationsAsync());
  }

  renderFooter() {
    const {
      selectedIngredient,
      replaceParams,
      ingredientToResolve
    } = this.state;
    const { selectedNotification, step, isLoading } = this.props;

    return (
      <div className={'modal-custom-btn-panel flex flex-end'}>
        <Button
          className={step === notificationsCenterSteps.NOTIFICATIONS_STEP ? 'mui-btn--success' : 'mui-btn--secondary'}
          onClick={() => this.closeModal()}
          disabled={isLoading}
        >
          Close
        </Button>

        {
          [notificationsCenterSteps.INGREDIENT_REPLACEMENT_STEP, notificationsCenterSteps.SET_QUANTITY_STEP].includes(step) ?
            (
              <Button
                className={'mui-btn--secondary'}
                onClick={() => this.changeNotificationsTab(step - 1)}
                disabled={(resolveBypassSet.includes(this.props.notifications.source) && step === notificationsCenterSteps.INGREDIENT_REPLACEMENT_STEP) || isLoading}
              >
                Back
              </Button>
            ) : null
        }

        {
          step === notificationsCenterSteps.INGREDIENT_REPLACEMENT_STEP ? (
            <Button
              className={'mui-btn--success'}
              onClick={() => this.changeNotificationsTab(notificationsCenterSteps.SET_QUANTITY_STEP)}
              disabled={!selectedIngredient || isLoading}
            >
              Next: Quantity
            </Button>
          ) : null
        }

        {
          step === notificationsCenterSteps.SET_QUANTITY_STEP ? (
            <Button
              className={'mui-btn--success'}       
              onClick={() => this.saveCostRollup(selectedIngredient, replaceParams, selectedNotification.id, ingredientToResolve.supc)}
              disabled={isLoading}
            >
              Save Changes
            </Button>
          ) : null
        }

      </div>
    );
  }

  handleCloseUnableToResolveModal = () => {
    const { selectedNotification, dispatch } = this.props;
    // call action to Close notification and remove from store
    this.handleCloseNotification(selectedNotification.id);
    this.setState({ isUnableToResolveModalOpen: false });
    dispatch(setSelectedNotification(null));
  }

  /**
   * The info modal to notify when user try to resolve an unavailable item
   * If the ingredients have been already removed from the recipes
   */
  renderUnableToResolveModal() {
    const { isUnableToResolveModalOpen } = this.state;
    return (
      <div className='alert-modal confirm'>
        <Modal
          open={ isUnableToResolveModalOpen }
          contentComponent={<div className={ 'common-overlay-content dialog-small-body-cont' }>
            <h2 className={ 'm-0' }>Unable to resolve</h2>
            <div className='mt-15'>
              <p>This Product is no longer used in Recipes and Batch Recipes.</p>
            </div>
          </div>}
          footerComponent={ <div className='flex justify-end'>
            <Button
              className={ 'mui-btn--success' }
              onClick={ this.handleCloseUnableToResolveModal }
            >
              Close
            </Button>
          </div>}
          hideCloseButton={ true }
          singleColumn={ true }
        />
      </div>
    );
  }

  render() {
    const { isModalOpen } = this.props;
    return (
      <Modal
        open={ isModalOpen }
        headerComponent={ this.renderHeader() }
        footerComponent={ this.renderFooter() }
        onCloseModal={ this.closeModal }
        contentComponent={ this.renderBody() }
        width={ 'common-large-overlay-body' }
      />
    );
  }
}
export default NotificationsCenter;
